import React from 'react'

const RangeOfMotion = (props) => {
    let { objectiveData, setObjectiveData, setSaveRangeOfMotionData, ObjectiveNotesProps, } = { ...props };
    let rangeOfMotion = objectiveData?.RangeOfMotion;

    const handleRangeOfMotion = (e) => {
        let { name } = e.target;
        console.log("handleObjectiveFindingobjectiveFindingData", name)
        setObjectiveData(prev => {
        console.log("handleObjectiveFindingobjectiveFindingData123", {
                ...prev,
                'RangeOfMotion': {
                    ...prev?.RangeOfMotion,
                    [name]: prev?.RangeOfMotion?.[name] === "true" ? "false" : "true",
                },
            })
            return ({
                ...prev,
                'RangeOfMotion': {
                    ...prev?.RangeOfMotion,
                    [name]: prev?.RangeOfMotion?.[name] === "true" ? "false" : "true",
                },
            });
        });

        setSaveRangeOfMotionData(prev => ({
            ...prev,
            [name]: prev[name] === "true" ? "false" : "true"
        }));
    }

    const handleChangeRangeOfMotionText = (e) => {
        let { name, value } = e.target;
        console.log("handleObjectiveFindingobjectiveFindingData", name)
        setObjectiveData(prev => {
        console.log("handleObjectiveFindingobjectiveFindingData123", {
                ...prev,
                'RangeOfMotion': { ...prev?.RangeOfMotion, [name]: value },
            })
            return ({
                ...prev,
                'RangeOfMotion': { ...prev?.RangeOfMotion, [name]: value },
            });
        });

        setSaveRangeOfMotionData(prev => ({ ...prev, [name]: value }));

    }
  return (
    <div className="d-flex flex-column gap-1">
        {/* <p className="heading fs-13 lh-normal">Range of Motion (ROM):</p> */}
        <div className="d-flex gap-40 flex-wrap row-gap-10">
        <div className="d-flex flex-column gap-2">
            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="PT_ROM_CervicalSpine"
                    checked={rangeOfMotion?.PT_ROM_CervicalSpine === "true"}
                    onChange={handleRangeOfMotion}
                />
            </div>
            <p className="text lh-12">Cervical Spine</p>
            </label>
            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="PT_ROM_ThoracicLumbarSpine"
                    checked={rangeOfMotion?.PT_ROM_ThoracicLumbarSpine === "true"}
                    onChange={handleRangeOfMotion}
                />
            </div>
            <p className="text lh-12">Thoracic & Lumbar Spine</p>
            </label>
        </div>

        <div className="d-flex flex-column gap-2">
            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="PT_ROM_Shoulder"
                    checked={rangeOfMotion?.PT_ROM_Shoulder === "true"}
                    onChange={handleRangeOfMotion}
                />
            </div>
            <p className="text lh-12">Shoulder</p>
            </label>
            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="PT_ROM_Elbow"
                    checked={rangeOfMotion?.PT_ROM_Elbow === "true"}
                    onChange={handleRangeOfMotion}
                />
            </div>
            <p className="text lh-12">Elbow</p>
            </label>
        </div>

        <div className="d-flex flex-column gap-2">
            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="PT_ROM_Forearm"
                    checked={rangeOfMotion?.PT_ROM_Forearm === "true"}
                    onChange={handleRangeOfMotion}
                />
            </div>
            <p className="text lh-12">Forearm</p>
            </label>
            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="PT_ROM_Wrist"
                    checked={rangeOfMotion?.PT_ROM_Wrist === "true"}
                    onChange={handleRangeOfMotion}
                />
            </div>
            <p className="text lh-12">Wrist</p>
            </label>
        </div>

        <div className="d-flex flex-column gap-2">
            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="PT_ROM_Hip"
                    checked={rangeOfMotion?.PT_ROM_Hip === "true"}
                    onChange={handleRangeOfMotion}
                />
            </div>
            <p className="text lh-12">Hip</p>
            </label>
            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="PT_ROM_Knee"
                    checked={rangeOfMotion?.PT_ROM_Knee === "true"}
                    onChange={handleRangeOfMotion}
                />
            </div>
            <p className="text lh-12">Knee</p>
            </label>
        </div>

        <div className="d-flex flex-column gap-2">
            <label className="d-flex align-items-center gap-6 user-select-none">
            <div className="custom_check_box d-flex">
                <input 
                    type="checkbox"
                    className="form-check-input m-0 p-0"
                    name="PT_ROM_Ankle"
                    checked={rangeOfMotion?.PT_ROM_Ankle === "true"}
                    onChange={handleRangeOfMotion}
                />
            </div>
            <p className="text lh-12">Ankle</p>
            </label>
        </div>

        </div>

        {/* Cervical Spine ROM */}
        {rangeOfMotion?.PT_ROM_CervicalSpine === "true" ? 
        <div className="d-flex flex-column gap-1">
            <p className="heading">Cervical Spine ROM:</p>
            <table className='w-max-content'>
                <thead>
                <tr>
                    <th className="heading text-start font-m">Flexion</th>
                    <th className="heading" colSpan={2}>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_CS_Flexion"
                        id="PT_ROM_CS_Flexion"
                        value={rangeOfMotion?.PT_ROM_CS_Flexion}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Extension</p>
                    </td>
                    <td colSpan={2}>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_CS_Extension"
                        id="PT_ROM_CS_Extension"
                        value={rangeOfMotion?.PT_ROM_CS_Extension}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
                <thead>
                <tr>
                    <th className="heading"></th>
                    <th className="heading">LEFT</th>
                    <th className="heading">RIGHT</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Lateral Flexion</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_CS_LateralFlexionLeft"
                        id="PT_ROM_CS_LateralFlexionLeft"
                        value={rangeOfMotion?.PT_ROM_CS_LateralFlexionLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_CS_LateralFlexionRight"
                        id="PT_ROM_CS_LateralFlexionRight"
                        value={rangeOfMotion?.PT_ROM_CS_LateralFlexionRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Rotation</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_CS_RotationLeft"
                        id="PT_ROM_CS_RotationLeft"
                        value={rangeOfMotion?.PT_ROM_CS_RotationLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_CS_RotationRight"
                        id="PT_ROM_CS_RotationRight"
                        value={rangeOfMotion?.PT_ROM_CS_RotationRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
            <div className="input">
                <div className={"input"}>
                <textarea
                    className="form-control"
                    name="PT_ROM_CS_Notes"
                    id="PT_ROM_CS_Notes"
                    autoComplete='off'
                    rows={1}
                    value={rangeOfMotion?.PT_ROM_CS_Notes}
                    onChange={handleChangeRangeOfMotionText}
                />
                </div>
            </div>
        </div> : <></>}

        {/* Thoracic & Lumbar Spine ROM  */}
        {rangeOfMotion?.PT_ROM_ThoracicLumbarSpine === "true" ?
        <div className="d-flex flex-column gap-1">
            <p className="heading">Thoracic & Lumbar Spine ROM:</p>
            <table className='w-max-content'>
                <thead>
                <tr>
                    <th className="heading text-start font-m">Flexion</th>
                    <th className="heading" colSpan={2}>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_TLS_Flexion"
                        id="PT_ROM_TLS_Flexion"
                        value={rangeOfMotion?.PT_ROM_TLS_Flexion}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Extension</p>
                    </td>
                    <td colSpan={2}>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_TLS_Extension"
                        id="PT_ROM_TLS_Extension"
                        value={rangeOfMotion?.PT_ROM_TLS_Extension}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
                <thead>
                <tr>
                    <th className="heading"></th>
                    <th className="heading">LEFT</th>
                    <th className="heading">RIGHT</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Lateral Flexion</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_TLS_LateralFlexionLeft"
                        id="PT_ROM_TLS_LateralFlexionLeft"
                        value={rangeOfMotion?.PT_ROM_TLS_LateralFlexionLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_TLS_LateralFlexionRight"
                        id="PT_ROM_TLS_LateralFlexionRight"
                        value={rangeOfMotion?.PT_ROM_TLS_LateralFlexionRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Rotation</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_TLS_RotationLeft"
                        id="PT_ROM_TLS_RotationLeft"
                        value={rangeOfMotion?.PT_ROM_TLS_RotationLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_TLS_RotationRight"
                        id="PT_ROM_TLS_RotationRight"
                        value={rangeOfMotion?.PT_ROM_TLS_RotationRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
            <div className="input">
                <div className={"input"}>
                <textarea
                    className="form-control"
                    autoComplete='off'
                    rows={1}
                    name="PT_ROM_TLS_Notes"
                    id="PT_ROM_TLS_Notes"
                    value={rangeOfMotion?.PT_ROM_TLS_Notes}
                    onChange={handleChangeRangeOfMotionText}
                />
                </div>
            </div>
        </div> : <></>}

        {/* Shoulder ROM  */}

        {rangeOfMotion?.PT_ROM_Shoulder === "true" ?
        <div className="d-flex flex-column gap-1">
            <p className="heading">Shoulder ROM:</p>
            <table className='w-max-content'>
                <thead>
                <tr>
                    <th className="heading"></th>
                    <th className="heading">LEFT</th>
                    <th className="heading">RIGHT</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Flexion</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Shoulder_FlexionLeft"
                        id="PT_ROM_Shoulder_FlexionLeft"
                        value={rangeOfMotion?.PT_ROM_Shoulder_FlexionLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Shoulder_FlexionRight"
                        id="PT_ROM_Shoulder_FlexionRight"
                        value={rangeOfMotion?.PT_ROM_Shoulder_FlexionRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Extension</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Shoulder_ExtensionLeft"
                        id="PT_ROM_Shoulder_ExtensionLeft"
                        value={rangeOfMotion?.PT_ROM_Shoulder_ExtensionLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Shoulder_ExtensionRight"
                        id="PT_ROM_Shoulder_ExtensionRight"
                        value={rangeOfMotion?.PT_ROM_Shoulder_ExtensionRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Abduction</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Shoulder_AbductionLeft"
                        id="PT_ROM_Shoulder_AbductionLeft"
                        value={rangeOfMotion?.PT_ROM_Shoulder_AbductionLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Shoulder_AbductionRight"
                        id="PT_ROM_Shoulder_AbductionRight"
                        value={rangeOfMotion?.PT_ROM_Shoulder_AbductionRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Adduction</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Shoulder_AdductionLeft"
                        id="PT_ROM_Shoulder_AdductionLeft"
                        value={rangeOfMotion?.PT_ROM_Shoulder_AdductionLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Shoulder_AdductionRight"
                        id="PT_ROM_Shoulder_AdductionRight"
                        value={rangeOfMotion?.PT_ROM_Shoulder_AdductionRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Internal Rotation</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Shoulder_InternalRotationLeft"
                        id="PT_ROM_Shoulder_InternalRotationLeft"
                        value={rangeOfMotion?.PT_ROM_Shoulder_InternalRotationLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Shoulder_InternalRotationRight"
                        id="PT_ROM_Shoulder_InternalRotationRight"
                        value={rangeOfMotion?.PT_ROM_Shoulder_InternalRotationRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">External Rotation</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Shoulder_ExternalRotationLeft"
                        id="PT_ROM_Shoulder_ExternalRotationLeft"
                        value={rangeOfMotion?.PT_ROM_Shoulder_ExternalRotationLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Shoulder_ExternalRotationRight"
                        id="PT_ROM_Shoulder_ExternalRotationRight"
                        value={rangeOfMotion?.PT_ROM_Shoulder_ExternalRotationRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
            <div className="input">
                <div className={"input"}>
                <textarea
                    className="form-control"
                    autoComplete='off'
                    rows={1}
                    name="PT_ROM_Shoulder_Notes"
                    id="PT_ROM_Shoulder_Notes"
                    value={rangeOfMotion?.PT_ROM_Shoulder_Notes}
                    onChange={handleChangeRangeOfMotionText}
                />
                </div>
            </div>
        </div> : <></>}

        {/* Elbow  ROM  */}

        {rangeOfMotion?.PT_ROM_Elbow === "true" ?
        <div className="d-flex flex-column gap-1">
            <p className="heading">Elbow ROM:</p>
            <table className='w-max-content'>
                <thead>
                <tr>
                    <th className="heading"></th>
                    <th className="heading">LEFT</th>
                    <th className="heading">RIGHT</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Flexion</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Elbow_FlexionLeft"
                        id="PT_ROM_Elbow_FlexionLeft"
                        value={rangeOfMotion?.PT_ROM_Elbow_FlexionLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Elbow_FlexionRight"
                        id="PT_ROM_Elbow_FlexionRight"
                        value={rangeOfMotion?.PT_ROM_Elbow_FlexionRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Extension</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Elbow_ExtensionLeft"
                        id="PT_ROM_Elbow_ExtensionLeft"
                        value={rangeOfMotion?.PT_ROM_Elbow_ExtensionLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Elbow_ExtensionRight"
                        id="PT_ROM_Elbow_ExtensionRight"
                        value={rangeOfMotion?.PT_ROM_Elbow_ExtensionRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
            <div className="input">
                <div className={"input"}>
                <textarea
                    className="form-control"
                    autoComplete='off'
                    rows={1}
                    name="PT_ROM_Elbow_Notes"
                    id="PT_ROM_Elbow_Notes"
                    value={rangeOfMotion?.PT_ROM_Elbow_Notes}
                    onChange={handleChangeRangeOfMotionText}
                />
                </div>
            </div>
        </div> : <></>}

        {/* Forearm   ROM  */}

        {rangeOfMotion?.PT_ROM_Forearm === "true" ?
        <div className="d-flex flex-column gap-1">
            <p className="heading">Forearm ROM:</p>
            <table className='w-max-content'>
                <thead>
                <tr>
                    <th className="heading"></th>
                    <th className="heading">LEFT</th>
                    <th className="heading">RIGHT</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Pronation</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Forearm_PronationLeft"
                        id="PT_ROM_Forearm_PronationLeft"
                        value={rangeOfMotion?.PT_ROM_Forearm_PronationLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Forearm_PronationRight"
                        id="PT_ROM_Forearm_PronationRight"
                        value={rangeOfMotion?.PT_ROM_Forearm_PronationRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Supination</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Forearm_SupinationLeft"
                        id="PT_ROM_Forearm_SupinationLeft"
                        value={rangeOfMotion?.PT_ROM_Forearm_SupinationLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Forearm_SupinationRight"
                        id="PT_ROM_Forearm_SupinationRight"
                        value={rangeOfMotion?.PT_ROM_Forearm_SupinationRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
            <div className="input">
                <div className={"input"}>
                <textarea
                    className="form-control"
                    autoComplete='off'
                    rows={1}
                    name="PT_ROM_Forearm_Notes"
                    id="PT_ROM_Forearm_Notes"
                    value={rangeOfMotion?.PT_ROM_Forearm_Notes}
                    onChange={handleChangeRangeOfMotionText}
                />
                </div>
            </div>
        </div> : <></>}

        {/* Wrist ROM  */}

        {rangeOfMotion?.PT_ROM_Wrist === "true" ?
        <div className="d-flex flex-column gap-1">
            <p className="heading">Wrist ROM:</p>
            <table className='w-max-content'>
                <thead>
                <tr>
                    <th className="heading"></th>
                    <th className="heading">LEFT</th>
                    <th className="heading">RIGHT</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Flexion</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Wrist_FlexionLeft"
                        id="PT_ROM_Wrist_FlexionLeft"
                        value={rangeOfMotion?.PT_ROM_Wrist_FlexionLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Wrist_FlexionRight"
                        id="PT_ROM_Wrist_FlexionRight"
                        value={rangeOfMotion?.PT_ROM_Wrist_FlexionRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Extension</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Wrist_ExtensionLeft"
                        id="PT_ROM_Wrist_ExtensionLeft"
                        value={rangeOfMotion?.PT_ROM_Wrist_ExtensionLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Wrist_ExtensionRight"
                        id="PT_ROM_Wrist_ExtensionRight"
                        value={rangeOfMotion?.PT_ROM_Wrist_ExtensionRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Radial Deviation</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Wrist_RadialDeviationLeft"
                        id="PT_ROM_Wrist_RadialDeviationLeft"
                        value={rangeOfMotion?.PT_ROM_Wrist_RadialDeviationLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Wrist_RadialDeviationRight"
                        id="PT_ROM_Wrist_RadialDeviationRight"
                        value={rangeOfMotion?.PT_ROM_Wrist_RadialDeviationRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Ulnar Deviation</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Wrist_UlnarDeviationLeft"
                        id="PT_ROM_Wrist_UlnarDeviationLeft"
                        value={rangeOfMotion?.PT_ROM_Wrist_UlnarDeviationLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Wrist_UlnarDeviationRight"
                        id="PT_ROM_Wrist_UlnarDeviationRight"
                        value={rangeOfMotion?.PT_ROM_Wrist_UlnarDeviationRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
            <div className="input">
                <div className={"input"}>
                <textarea
                    className="form-control"
                    autoComplete='off'
                    rows={1}
                    name="PT_ROM_Wrist_Notes"
                    id="PT_ROM_Wrist_Notes"
                    value={rangeOfMotion?.PT_ROM_Wrist_Notes}
                    onChange={handleChangeRangeOfMotionText}
                />
                </div>
            </div>
        </div> : <></>}

        {/* Hip ROM  */}

        {rangeOfMotion?.PT_ROM_Hip === "true" ?
        <div className="d-flex flex-column gap-1">
            <p className="heading">Hip ROM:</p>
            <table className='w-max-content'>
                <thead>
                <tr>
                    <th className="heading"></th>
                    <th className="heading">LEFT</th>
                    <th className="heading">RIGHT</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Flexion</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Hip_FlexionLeft"
                        id="PT_ROM_Hip_FlexionLeft"
                        value={rangeOfMotion?.PT_ROM_Hip_FlexionLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Hip_FlexionRight"
                        id="PT_ROM_Hip_FlexionRight"
                        value={rangeOfMotion?.PT_ROM_Hip_FlexionRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Extension</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Hip_ExtensionLeft"
                        id="PT_ROM_Hip_ExtensionLeft"
                        value={rangeOfMotion?.PT_ROM_Hip_ExtensionLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Hip_ExtensionRight"
                        id="PT_ROM_Hip_ExtensionRight"
                        value={rangeOfMotion?.PT_ROM_Hip_ExtensionRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Abduction</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Hip_AbductionLeft"
                        id="PT_ROM_Hip_AbductionLeft"
                        value={rangeOfMotion?.PT_ROM_Hip_AbductionLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Hip_AbductionRight"
                        id="PT_ROM_Hip_AbductionRight"
                        value={rangeOfMotion?.PT_ROM_Hip_AbductionRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Adduction</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Hip_AdductionLeft"
                        id="PT_ROM_Hip_AdductionLeft"
                        value={rangeOfMotion?.PT_ROM_Hip_AdductionLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Hip_AdductionRight"
                        id="PT_ROM_Hip_AdductionRight"
                        value={rangeOfMotion?.PT_ROM_Hip_AdductionRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Internal Rotation</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Hip_InternalRotationLeft"
                        id="PT_ROM_Hip_InternalRotationLeft"
                        value={rangeOfMotion?.PT_ROM_Hip_InternalRotationLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Hip_InternalRotationRight"
                        id="PT_ROM_Hip_InternalRotationRight"
                        value={rangeOfMotion?.PT_ROM_Hip_InternalRotationRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">External Rotation</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Hip_ExternalRotationLeft"
                        id="PT_ROM_Hip_ExternalRotationLeft"
                        value={rangeOfMotion?.PT_ROM_Hip_ExternalRotationLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Hip_ExternalRotationRight"
                        id="PT_ROM_Hip_ExternalRotationRight"
                        value={rangeOfMotion?.PT_ROM_Hip_ExternalRotationRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
            <div className="input">
                <div className={"input"}>
                <textarea
                    className="form-control"
                    autoComplete='off'
                    rows={1}
                    name="PT_ROM_Hip_Notes"
                    id="PT_ROM_Hip_Notes"
                    value={rangeOfMotion?.PT_ROM_Hip_Notes}
                    onChange={handleChangeRangeOfMotionText}
                />
                </div>
            </div>
        </div> : <></>}

        {/* Knee    ROM  */}

        {rangeOfMotion?.PT_ROM_Knee === "true" ?
        <div className="d-flex flex-column gap-1">
            <p className="heading">Knee ROM:</p>
            <table className='w-max-content'>
                <thead>
                <tr>
                    <th className="heading"></th>
                    <th className="heading">LEFT</th>
                    <th className="heading">RIGHT</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Flexion</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Knee_FlexionLeft"
                        id="PT_ROM_Knee_FlexionLeft"
                        value={rangeOfMotion?.PT_ROM_Knee_FlexionLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Knee_FlexionRight"
                        id="PT_ROM_Knee_FlexionRight"
                        value={rangeOfMotion?.PT_ROM_Knee_FlexionRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Extension</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Knee_ExtensionLeft"
                        id="PT_ROM_Knee_ExtensionLeft"
                        value={rangeOfMotion?.PT_ROM_Knee_ExtensionLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Knee_ExtensionRight"
                        id="PT_ROM_Knee_ExtensionRight"
                        value={rangeOfMotion?.PT_ROM_Knee_ExtensionRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
            <div className="input">
                <div className={"input"}>
                <textarea
                    className="form-control"
                    autoComplete='off'
                    rows={1}
                    name="PT_ROM_Knee_Notes"
                    id="PT_ROM_Knee_Notes"
                    value={rangeOfMotion?.PT_ROM_Knee_Notes}
                    onChange={handleChangeRangeOfMotionText}
                />
                </div>
            </div>
        </div> : <></>}

        {/* Ankle ROM  */}

        {rangeOfMotion?.PT_ROM_Ankle === "true" ?
        <div className="d-flex flex-column gap-1">
            <p className="heading">Ankle ROM:</p>
            <table className='w-max-content'>
                <thead>
                <tr>
                    <th className="heading"></th>
                    <th className="heading">LEFT</th>
                    <th className="heading">RIGHT</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td>
                    <p className="text font-m">Plantarflexion</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Ankle_PlantarflexionLeft"
                        id="PT_ROM_Ankle_PlantarflexionLeft"
                        value={rangeOfMotion?.PT_ROM_Ankle_PlantarflexionLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Ankle_PlantarflexionRight"
                        id="PT_ROM_Ankle_PlantarflexionRight"
                        value={rangeOfMotion?.PT_ROM_Ankle_PlantarflexionRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                <tr>
                    <td>
                    <p className="text font-m">Dorsiflexion</p>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Ankle_DorsiflexionLeft"
                        id="PT_ROM_Ankle_DorsiflexionLeft"
                        value={rangeOfMotion?.PT_ROM_Ankle_DorsiflexionLeft}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                    <td>
                    <div className='input mb-0'>
                        <input type="text"
                        className='form-control border-0 h-100 p-0'
                        name="PT_ROM_Ankle_DorsiflexionRight"
                        id="PT_ROM_Ankle_DorsiflexionRight"
                        value={rangeOfMotion?.PT_ROM_Ankle_DorsiflexionRight}
                        onChange={handleChangeRangeOfMotionText}
                        />
                    </div>
                    </td>
                </tr>
                </tbody>
            </table>
            <p className="heading cursor-pointer user-select-none w-max-content">Notes</p>
            <div className="input">
                <div className={"input"}>
                <textarea
                    className="form-control"
                    autoComplete='off'
                    rows={1}
                    name="PT_ROM_Ankle_Notes"
                    id="PT_ROM_Ankle_Notes"
                    value={rangeOfMotion?.PT_ROM_Ankle_Notes}
                    onChange={handleChangeRangeOfMotionText}
                />
                </div>
            </div>
        </div> : <></>}

    </div> 
  )
}

export default RangeOfMotion